import { useState } from "react";
import { ChevronDown, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const FilterPopover = ({ id, icon: Icon, title, value, options, onChange }) => {
  const [open, setOpen] = useState(false);
  const cur = options.find((o) => o.k === value) || options[0];
  const active = value !== options[0].k;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`${id}-button`}
          className={`flex h-11 min-w-0 flex-1 items-center gap-1.5 rounded-md border px-2 text-xs transition-colors ${active ? "border-[#D97706] bg-[#D97706]/10 text-[#F59E0B]" : "border-[#2D3442] bg-[#13171F] text-[#E8DFD1]"}`}
          style={active && cur.color ? { borderColor: cur.color, color: cur.color } : {}}>
          <Icon className="hidden h-3.5 w-3.5 shrink-0 min-[420px]:block" />
          <span className="min-w-0 flex-1 truncate text-left" data-testid={`${id}-value`}>{active ? cur.label : title}</span>
          <ChevronDown className="hidden h-3.5 w-3.5 shrink-0 opacity-60 min-[400px]:block" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="center" sideOffset={6} collisionPadding={12} className="w-[calc(100vw-1.5rem)] max-w-sm border-[#2D3442] bg-[#0F131A] p-3" data-testid={`${id}-popup`}>
        <div className="mb-2.5 flex items-center justify-between">
          <div className="lf-label">{title}</div>
          <button onClick={() => setOpen(false)} className="flex h-8 w-8 items-center justify-center rounded-md text-[#A8A090] hover:bg-[#1A202C] hover:text-[#F3EBDD]" aria-label="Close" data-testid={`${id}-close`}><X className="h-4 w-4" /></button>
        </div>
        <div className="grid max-h-[60dvh] grid-cols-2 gap-1.5 overflow-y-auto lf-scroll">
          {options.map((o) => {
            const on = o.k === value;
            return (
              <button key={o.k || "all"} onClick={() => { onChange(o.k); setOpen(false); }} data-testid={`${id}-option-${o.k || "all"}`}
                className={`flex min-h-[40px] items-center justify-between gap-1 rounded-sm border px-2.5 py-1.5 text-left text-xs transition-colors ${on ? "border-[#D97706] bg-[#D97706]/15 text-[#F59E0B]" : "border-[#2D3442] text-[#E8DFD1] hover:border-[#D97706]/50"}`}
                style={on && o.color ? { borderColor: o.color, color: o.color } : {}}>
                <span className="min-w-0 truncate">{o.label}</span>
                {o.count != null && <span className="shrink-0 opacity-60">{o.count}</span>}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
